import { render, staticRenderFns } from "./BtDashboardSharing.vue?vue&type=template&id=ed7e5694&"
import script from "./BtDashboardSharing.vue?vue&type=script&lang=js&"
export * from "./BtDashboardSharing.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardSharing.vue?vue&type=style&index=0&id=ed7e5694&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports